// 🔧 ticket_builder.js
// ✅ Purpose: Orchestrates Ticket demo data creation
// ✅ Features:
// - Generates ticket types and demo ticket holders
// - Seeds ticket data through repository layer
// - Updates DemoContext with ticket results
// - Returns standardized Demo Report results
// - Fully block-commented for clarity and future devs

import { generateTickets } from "./ticket_generator";
import { seedTickets } from "./ticket_seeder";
import { buildTicketReport } from "./ticket_report";

export const buildTickets = async ({ demoContext } = {}) => {
  console.log("🎫 Ticket Builder started.");

  const ticketPlan = generateTickets({ demoContext });

  const ticketResults = await seedTickets({
    demoContext,
    ticketPlan,
  });

  demoContext.tickets = {
    ticketTypes: ticketResults.ticketTypes || [],
    tickets: ticketResults.tickets || [],
    orders: ticketResults.orders || [],
  };

  return buildTicketReport({ ticketResults });
};
